<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Resumen de Ventas</strong>
          </div>
          <b-form>
            <b-form-group
              label="Fecha Desde"
              label-for="fechaDesde"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaDesde" 
                v-model="fechaDesde" 
                :state="fechaDesdeValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaDesdeFeedback">
                {{ fechaDesdeInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Hasta"
              label-for="fechaHasta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaHasta" 
                v-model="fechaHasta" 
                :state="fechaHastaValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaHastaFeedback">
                {{ fechaHastaInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarCliente">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !cliente,
                                  'fa fa-remove': cliente  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="cliente"
                  :value="clienteNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="searchClienteModal"
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-cliente
        :incluirInactivos="true"
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import export_xls_ventas from '../../mixins/export_xls_ventas';
import moment from 'moment';

export default {
  name: 'ABM',
  components: {
    appSearchCliente: SearchCliente,
    appMensaje: Mensaje
  },
  mixins: [
    export_xls_ventas,
    msjModal
  ],
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      fechaDesdeValida: null,
      fechaDesdeInvalidaMsj: '',
      fechaHastaValida: null,
      fechaHastaInvalidaMsj: '',
      // clienteValido: null,
      // clienteInvalidoMsj: '',

      fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
      fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
      cliente: null,

      labelCols: 2,
    }
  },
  computed: {
    clienteNombre() {
      return this.cliente? this.cliente.nombre.trim() : '';
    },
  },
  created() {
    
  },  
  methods: {
    validate() {
    },
    exportXls () {
      let execute = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let clienteId = 0;
      if (this.cliente) {
        clienteId = this.cliente.id;
      }

      let params = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        clienteId
      }

      if (execute) {
        this.showSpinner();
        this.$store.dispatch('ventas/getRptVentas', params)
          .then(() => {
            let exportRpt = Boolean(false); 
            let rptVentas = this.$store.getters['ventas/rptVentas'];

            if (rptVentas) {
              if (rptVentas.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              this.exportXLSRptVentas(rptVentas);
            } else {
              this.showModalMsj('No hay datos para exportar', null, null, 'light')
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    seleccionarCliente() {
      if (this.cliente) {
        this.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(item) {
      this.cliente = item;
      this.$refs.searchClienteModal.hide();
    },
  },
}
</script>

<style>
</style>
